const { VUE_APP_API_URL } = process.env

const getters = {
	sidebar: state => state.app.sidebar,
	language: state => state.app.language,
	size: state => state.app.size,
	device: state => state.app.device,
	visitedViews: state => state.tagsView.visitedViews,
	cachedViews: state => state.tagsView.cachedViews,
	token: state => state.user.token,
	// avatar: state => state.user.avatar,
	avatar: () => require('@/assets/logo/avatar.jpg'),
	name: state => state.user.name,
	permissions: state => state.user.permissions,
	hasRoles: state => state.user.hasRoles,
	permission_routes: state => state.permission.routes,
	errorLogs: state => state.errorLog.logs,
	tagWel: state => state.tags.tagWel,
	url: state => {
		if (VUE_APP_API_URL) return VUE_APP_API_URL
		const domain = window.location.hostname
		if (domain !== 'localhost') {
			return (
				window.location.protocol + '//' + domain + ':' + window.location.port
			)
		} else {
			// return state.aliBaseUrl || state.baseURL;
			return state.baseURL
			// return "https://yunshitangtest.xnzn.net"
		}
	},
	userInfo: state => state.user.userInfo
}
export default getters
